import { DarkMode } from 'app/account-settings/models/user.model';
import { Language } from 'app/core/language.service';

/** App-wide visual theme version. Orthogonal to dark/light: each version carries both modes. */
export enum AppTheme {
  Theme2025 = '2025-theme',
  Theme2026Golden = '2026-theme-golden',
  Theme2026BlueGold = '2026-theme-blue-gold',
}

export interface AdminSettings {
  adminLanguage: Language;
  adminTheme: DarkMode;
  adminToggle: boolean;
  aiFeatures: boolean;
  showServerSideCampaigns: boolean;
  cookieFeatures: boolean;
  versionHistory: boolean;
  undoRedo: boolean;
  adminAccountLanguage: string | null;
  appTheme: AppTheme;
}
